export default "__VITE_PUBLIC_ASSET__064ff125__"